import AppStore from '@v4/store/appStore'
import { useSectionMetaData } from '../../SectionItem.context'
import useStyles from './BaseContainer.styled'

export const useBaseContainer = ({
	minMarginTop,
	minMarginBottom,
	className,
	children,
	onLoad,
	onTransitionEnd,
	onAnimationEnd,
}) => {
	const autoHeight = AppStore.useStoreState(state => state.general.autoHeight)
	const metaData = useSectionMetaData()
	const classes = useStyles({
		minMarginTop,
		minMarginBottom,
		metaData,
		autoHeight,
	})

	return [
		{
			classes,
			className,
			children,
		},
		{
			handleLoad: onLoad,
			handleTransitionEnd: onTransitionEnd,
			handelAnimationEnd: onAnimationEnd,
		},
	]
}
